export const FRIENDS_REQUEST = 'FRIENDS_REQUEST';
export const FRIENDS_SUCCESS = 'FRIENDS_SUCCESS';
export const FRIENDS_FAIL = 'FRIENDS_FAIL';

export const FRIENDS_SELECT = 'FRIEND_SELECT';
export const FRIENDS_SELECTALL = 'FRIEND_SELECTALL';

export const FRIENDSDEL_REQUEST = 'FRIENDSDEL_REQUEST';
export const FRIENDSDEL_SUCCESS = 'FRIENDSDEL_SUCCESS';
export const FRIENDSDEL_FAIL = 'FRIENDSDEL_FAIL';



// WEBPACK FOOTER //
// ./src/constants/Friends.js